module.exports = __webpack_public_path__ + "img/thumb2.4844324d.svg";